module.exports = __webpack_public_path__ + "../resources/img/home.3a337071.png";